export const defaultReduceOptions = (prevOptions, loadedOptions) => [
  ...prevOptions,
  ...loadedOptions,
];
